// src/modules/components/FooterCADPro/index.js
import React from 'react';
import {
  FooterContainer,
  FooterContent,
  FooterMain,
  FooterBrand,
  Logo,
  BrandText,
  FooterLinks,
  FooterLinkGroup,
  GroupTitle,
  FooterLink,
  FooterContact,
  ContactItem,
  FooterBottom,
  Copyright
} from './styles';

import { 
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaLinkedin,
  FaMapMarkerAlt
} from 'react-icons/fa';

import logoCADPro from '../../../assets/logoCADPro.svg';

export const FooterCADPro = () => {
  const emailLink = "mailto:contato@vegarobotics.com.br?subject=Solicitação de Orçamento - Engenharia CADPro";
  const whatsappLink = "https://wa.me/5511944271000?text=Olá! Tenho uma dúvida sobre os serviços de engenharia.";
  const linkedinLink = "https://www.linkedin.com/showcase/cadpro-engenharia-aplicada";

  return (
    <FooterContainer id="contato">
      <FooterContent>
        <FooterMain>
          <FooterBrand>
            <Logo to="/cadpro">
              <img src={logoCADPro} alt="CADPro" />
            </Logo>
            <BrandText>
              Terceirize seus projetos
              <br />
              Simplifique sua operação
            </BrandText>
          </FooterBrand>

          <FooterLinks>
            <FooterLinkGroup>
              <GroupTitle>Navegação</GroupTitle>
              <FooterLink href="#servicos">Serviços</FooterLink>
              <FooterLink href="#depoimentos">Depoimentos</FooterLink>
              <FooterLink href="#contato">Contato</FooterLink>
            </FooterLinkGroup>

            <FooterLinkGroup>
              <GroupTitle>Serviços</GroupTitle>
              <FooterLink href="#servicos">Análise e Planejamento</FooterLink>
              <FooterLink href="#servicos">Ferramentas de Estampagem</FooterLink>
              <FooterLink href="#servicos">Máquinas e Dispositivos</FooterLink>
              <FooterLink href="#servicos">Detalhamento e Entrega</FooterLink>
            </FooterLinkGroup>
          </FooterLinks>

          <FooterContact>
            <GroupTitle>Contato</GroupTitle>
            {/* <ContactItem href="tel:+5511944271000">
              <FaPhone />
              <span>(11) 94427-1000</span>
            </ContactItem> */}
            <ContactItem href={emailLink}>
              <FaEnvelope />
              <span>contato@vegarobotics.com.br</span>
            </ContactItem>
            <ContactItem href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
              <span>Dúvidas via WhatsApp</span>
            </ContactItem>
            <ContactItem href={linkedinLink} target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
              <span>LinkedIn</span>
            </ContactItem>
            <ContactItem href="https://maps.google.com/?q=Av.+Alan+Turing,+345+-+Sala+11+-+Cidade+Universitária,+Campinas+-+SP" target="_blank" rel="noopener noreferrer">
              <FaMapMarkerAlt />
              <span>Av. Alan Turing, 345 - Sala 11<br />Campinas - SP, 13083-898</span>
            </ContactItem>
          </FooterContact>
        </FooterMain>

        <FooterBottom>
          <Copyright>
            © {new Date().getFullYear()} CADPro™.
            Serviço de Engenharia Aplicada da Vega Robotics.
          </Copyright>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default FooterCADPro;